import React from 'react';
import { Link } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar, faBookOpen, faDownload, faCertificate, faUserGroup,
  faSquare, faTasks, faVideo, faHistory, faTrophy,
  faHandPointRight,
  faUserCog
} from '@fortawesome/free-solid-svg-icons';
import './styles/BookShelf.css';
import './styles/Learning.css';
import learningimage from '../../assets/pageimages/Learning.webp';

function LearningHome() {
  return (
    <div className="min-h-screen bg-black py-2">
      <div className='border-b border-blue-400 mb-2'>
        <h2 className="text-lg lg:text-xl font-extrabold text-center text-yellow-200 mb-2 p-2">
          📖 Think5Whys Learnings
        </h2>
      </div>

      {/* Image Section */}
      {/* <div className="w-full lg:w-3/4">
        <div className="flex justify-center mb-8">
          <img
            src={learningimage}
            alt="Think5Whys Learnings"
            className="w-full sm:w-3/4 lg:w-1/4 rounded-lg shadow-lg"
          />
        </div>
      </div> */}

      {/* Grid Section */}
      {/* <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 px-2">        
        <CardLink to="/assignments-think5whys" icon={faTasks} emoji="📝" text="Think5Whys DIY Assignments" />
        <CardLink to="/practice-mcq" icon={faStar} emoji="⭐" text="Practice Think5Whys Books MCQ" />
        <CardLink to="/practice-sat" icon={faStar} emoji="📝" text="Practice Think5Whys Books Short Answer Type" />
        <CardLink to="/certification-test-think5whys" icon={faSquare} emoji="🎓" text="Think5Whys Certification Test" />
        <CardLink to="/my-certificates-think5whys" icon={faCertificate} emoji="📜" text="My Think5Whys Certificate" />
        <CardLink to="/download-templates" icon={faDownload} emoji="📂" text="Downloads Think5Whys Templates" />
        <CardLink to="/videos" icon={faVideo} emoji="🎥" text="Think5Whys Videos" />
        <CardLink to="/training-workshops" icon={faUserGroup} emoji="👥" text="Think5Whys Training & Workshops" />
        <CardLink to="/assignments-others" icon={faTasks} emoji="📝" text="Other DIY Assignments" />
        <CardLink to="/practice-mcqothers" icon={faStar} emoji="⭐" text="Practice Non Think5Whys Books MCQ" />
        <CardLink to="/certification-test-others" icon={faSquare} emoji="🎓" text="Other Certification Test" />
        <CardLink to="/my-certificates-others" icon={faCertificate} emoji="📜" text="My Other Certificates" />
        <CardLink to="/sample-certificates" icon={faCertificate} emoji="📜" text="Sample Certificates" />
        <CardLink to="/practice-matching" icon={faHistory} emoji="🧩" text="Practice Matching Questions" />
        <CardLink to="/practice-history" icon={faHistory} emoji="📖" text="Practice History" />
        <CardLink to="/marks-tracker-list" icon={faHandPointRight} emoji="📝" text="Academic Marks Tracker" />
        <CardLink to="/mylearningnotes" icon={faBookOpen} emoji="📓" text="My Learning Notes" />
        <CardLink to="/iamflying" icon={faBookOpen} emoji="🕊️" text="I Am Flying On The Wall" />

        <CardNoLink icon={faHistory} emoji="📚" text="My Learning History" />
        <CardNoLink icon={faStar} emoji="⭐" text="Practice Non Think5Whys Books Short Answer Type" />        
        <CardNoLink icon={faBookOpen} emoji="📚" text="My Mentors" />
        <CardNoLink icon={faBookOpen} emoji="📚" text="My Flyers on The Wall" />
        <CardNoLink icon={faBookOpen} emoji="📚" text="My Digital Co-Readers Log" />
        <CardNoLink icon={faBookOpen} emoji="📚" text="Mentoring" />
        <CardNoLink icon={faUserCog} emoji="🧑‍🏫" text="Readfluencer Dashbaord" />
        <CardNoLink icon={faUserCog} emoji="🧑‍🏫" text="Readfluencing" />
      </div> */}

      {/* Grid Section */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 p-2 break-words">
        {/* Active Links */}
        <CardLink
          to="/assignments-think5whys"
          icon={faTasks}
          emoji="📝"
          text="Think5Whys DIY Assignments"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/practice-mcq"
          icon={faStar}
          emoji="⭐"
          text="Practice Think5Whys Books MCQ"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/practice-sat"
          icon={faStar}
          emoji="📝"
          text="Practice Think5Whys Books Short Answer Type"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/certification-test-think5whys"
          icon={faSquare}
          emoji="🎓"
          text="Think5Whys Certification Test"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/my-certificates-think5whys"
          icon={faCertificate}
          emoji="📜"
          text="My Think5Whys Certificate"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/download-templates"
          icon={faDownload}
          emoji="📂"
          text="Downloads Think5Whys Templates"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/videos"
          icon={faVideo}
          emoji="🎥"
          text="Think5Whys Videos"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/training-workshops"
          icon={faUserGroup}
          emoji="👥"
          text="Think5Whys Training & Workshops"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/assignments-others"
          icon={faTasks}
          emoji="📝"
          text="Other DIY Assignments"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/practice-mcqothers"
          icon={faStar}
          emoji="⭐"
          text="Practice Non Think5Whys Books MCQ"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/certification-test-others"
          icon={faSquare}
          emoji="🎓"
          text="Other Certification Test"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/my-certificates-others"
          icon={faCertificate}
          emoji="📜"
          text="My Other Certificates"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/sample-certificates"
          icon={faCertificate}
          emoji="📜"
          text="Sample Certificates"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/practice-matching"
          icon={faHistory}
          emoji="🧩"
          text="Practice Matching Questions"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/practice-history"
          icon={faHistory}
          emoji="📖"
          text="Practice History"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/marks-tracker-list"
          icon={faHandPointRight}
          emoji="📝"
          text="Academic Marks Tracker"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/mylearningnotes"
          icon={faBookOpen}
          emoji="📓"
          text="My Learning Notes"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />
        <CardLink
          to="/iamflying"
          icon={faBookOpen}
          emoji="🕊️"
          text="I Am Flying On The Wall"
          className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105 flex flex-col items-center text-center"
        />

        {/* Disabled / Placeholder Links */}
        <CardNoLink
          icon={faHistory}
          emoji="📚"
          text="My Learning History"
          className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg shadow flex flex-col items-center text-center cursor-not-allowed opacity-60"
        />
        <CardNoLink
          icon={faStar}
          emoji="⭐"
          text="Practice Non Think5Whys Books Short Answer Type"
          className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg shadow flex flex-col items-center text-center cursor-not-allowed opacity-60"
        />
        <CardNoLink
          icon={faBookOpen}
          emoji="📚"
          text="My Mentors"
          className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg shadow flex flex-col items-center text-center cursor-not-allowed opacity-60"
        />
        <CardNoLink
          icon={faBookOpen}
          emoji="📚"
          text="My Flyers on The Wall"
          className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg shadow flex flex-col items-center text-center cursor-not-allowed opacity-60"
        />
        <CardNoLink
          icon={faBookOpen}
          emoji="📚"
          text="My Digital Co-Readers Log"
          className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg shadow flex flex-col items-center text-center cursor-not-allowed opacity-60"
        />
        <CardNoLink
          icon={faBookOpen}
          emoji="📚"
          text="Mentoring"
          className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg shadow flex flex-col items-center text-center cursor-not-allowed opacity-60"
        />
        <CardNoLink
          icon={faUserCog}
          emoji="🧑‍🏫"
          text="Readfluencer Dashboard"
          className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg shadow flex flex-col items-center text-center cursor-not-allowed opacity-60"
        />
        <CardNoLink
          icon={faUserCog}
          emoji="🧑‍🏫"
          text="Readfluencing"
          className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg shadow flex flex-col items-center text-center cursor-not-allowed opacity-60"
        />
      </div>


      <div className="mt-2 mb-2 w-full text-center">
        <Link to="/thinkleticsdashboard" className="bg-yellow-500 hover:bg-yellow-600 text-white rounded-lg py-4 px-8 inline-block shadow-md">
          <FontAwesomeIcon icon={faTrophy} className="mr-2 text-sm lg:text-lg" />
          <span className="text-sm lg:text-lg font-bold">Go to Thinkletics</span>
        </Link>
      </div>

      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
    </footer>  
  </div>
  );
}

const CardLink = ({ to, icon, emoji, text, delay }) => (
  <Link
    to={to}
    className="bg-gray-800 w-48 h-20 p-2 rounded-lg shadow-lg transition-all duration-300 ease-in-out hover:scale-105 hover:bg-gray-700 hover:shadow-xl flex items-center text-xs text-blue-200 hover:text-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500 border border-gray-700 group animate-fade-in"
    style={{ animationDelay: `${delay}ms` }}
  >
    <div className="flex items-center mr-3">
      <span className="text-xl mr-2 group-hover:scale-110 transition-transform duration-300">{emoji}</span>
      <span className="flex-1 text-left transform translate-y-0 group-hover:translate-y-[-2px] transition-transform duration-300 text-sm lg:text-m break-words">
        {text}
      </span>   
   </div>
  </Link>
);

// CardNoLink Component
const CardNoLink = ({ icon, emoji, text, delay }) => (
  <div 
    className="bg-gray-700 w-48 p-2 rounded-lg shadow-lg transition-all duration-300 ease-in-out hover:scale-105 hover:bg-gray-700 hover:shadow-xl flex items-center text-xs text-blue-200 hover:text-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500 border border-gray-700 group animate-fade-in"
    style={{ animationDelay: `${delay}ms` }}
  >
    <div className="flex items-center mr-3">
      <span className="text-xl mr-2 group-hover:scale-110 transition-transform duration-300">{emoji}</span>
      <span className="flex-1 text-left transform translate-y-0 group-hover:translate-y-[-2px] transition-transform duration-300 text-sm lg:text-m break-words">
        {text}
      </span>
    </div>       
  </div>
);


export default LearningHome;
